// Country-team display helpers shared by the Productivity overview (WO-7/21 Track A) and the
// Admin home's team-health sections (WO-2026-08-19). Team names are countries (plus a few
// program hubs) — best-effort flags, 🌍 otherwise.
export const TEAM_FLAGS: Record<string, string> = {
  "United States": "🇺🇸", Berkeley: "🇺🇸", India: "🇮🇳", Nigeria: "🇳🇬", Brazil: "🇧🇷",
  Philippines: "🇵🇭", Bangladesh: "🇧🇩", Mexico: "🇲🇽", Peru: "🇵🇪", "South Africa": "🇿🇦",
  "Cape Town": "🇿🇦", Uganda: "🇺🇬", Vietnam: "🇻🇳", Ethiopia: "🇪🇹",
};

export const flagFor = (team: string): string => TEAM_FLAGS[team] ?? "🌍";
